import React, { useEffect, useState } from 'react';
import api from '../../lib/adminApi';

// Admin site switcher. Persists choice in localStorage; apiClient picks it up
// and sends X-Admin-Site on every request.
export default function SiteSwitcher() {
  const [sites, setSites] = useState([]);
  const [active, setActive] = useState(() => localStorage.getItem('admin_active_site') || 'default');

  useEffect(() => {
    api.get('/api/admin/sites').then(d => setSites(d || [])).catch(() => {});
  }, []);

  function change(id) {
    setActive(id);
    localStorage.setItem('admin_active_site', id);
    // Reload so all in-flight admin queries re-fetch with the new site context.
    window.location.reload();
  }

  if (!sites.length) return null;
  return (
    <select value={active} onChange={e => change(e.target.value)}
            style={{ marginRight: 12, padding: 4 }}>
      <option value="default">Site: silvergames.ca</option>
      {sites.filter(s => s.id !== 'default').map(s => (
        <option key={s.id} value={s.id}>Site: {s.domain || s.name}</option>
      ))}
    </select>
  );
}
